import type { ApiListRequest, ApiListResponse } from "../@types/services/Api";
import type {
  MaterialRequestForm,
  MaterialRequestFormsFilter,
  MaterialRequestFormsOrder,
} from "../@types/services/MaterialRequestForm";
import { api } from "./api";

const API_BASE_URL = "/vbuyer/api/v2/material_request_forms";

export const fetchMaterialRequestForms = async ({
  filters,
  orders,
  ...rest
}: ApiListRequest<
  MaterialRequestFormsFilter,
  MaterialRequestFormsOrder
> = {}): Promise<ApiListResponse<MaterialRequestForm>> => {
  const response = await api.get<ApiListResponse<MaterialRequestForm>>("", {
    baseURL: API_BASE_URL,
    params: {
      ...filters,
      ...orders,
      ...rest,
    },
  });

  return response.data;
};

export const fetchMaterialRequestForm = async (
  id: MaterialRequestForm["id"],
): Promise<MaterialRequestForm> => {
  const response = await api.get<MaterialRequestForm>(`/${id}`, {
    baseURL: API_BASE_URL,
  });

  return response.data;
};

export const uploadMaterialRequestFormAttach = async (
  id: MaterialRequestForm["id"],
  attach: unknown,
): Promise<MaterialRequestForm> => {
  const response = await api.postForm<MaterialRequestForm>(
    `/${id}/mass_offer_upload`,
    attach,
    {
      baseURL: API_BASE_URL,
    },
  );

  return response.data;
};
